import { Api } from '@/services/Api'

export default {
  dashboardData (param) {
    return Api().post('/api/v1.0/dashboard', param)
  },
  getTotalPR (param) {
    return Api().post('/api/v1.0/totalPR', param)
  },
  getHeaderData(param) {
    return Api().post('/api/v1.0/think-header', param)
  },
  getPlantDetails() {
    return Api().get('/api/v2/plant/plantDetails')
  }
}
